var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.hideExpiry)?_c('div',{staticClass:"link-expiry"},[(_vm.timer)?_c('div',[_c('span',{staticClass:"text-color"},[_vm._v("Link will expire in")]),_c('span',{staticClass:"countdown",style:({
        color:
          _vm.isUserAdmin && _vm.isDarkModeToggleEnabled
            ? _vm.getColors.lightPrimaryColor
            : _vm.getColors.darkPrimaryColor
      })},[_vm._v(" "+_vm._s(_vm.hours)+" : "+_vm._s(_vm.minutes)+" : "+_vm._s(_vm.seconds)+" ")])]):_c('span',{staticClass:"expired"},[_vm._v("Link has expired")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }